import { render } from "./ScrollArrow.vue?vue&type=template&id=1cd33897&scoped=true"
import script from "./ScrollArrow.vue?vue&type=script&lang=js"
export * from "./ScrollArrow.vue?vue&type=script&lang=js"

import "./ScrollArrow.vue?vue&type=style&index=0&id=1cd33897&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd33897"]])

export default __exports__